import React, { useState, useEffect } from "react";
import Navbar from "../components/navBar";
import { useNavigate } from "react-router-dom";

const GameShowsPage = () => {
  const [gameShows, setGameShows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchGameShows = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/gameshows`);
        if (!response.ok) {
          throw new Error('Failed to fetch game shows');
        }
        const data = await response.json();
        setGameShows(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchGameShows();
  }, []);

  if (loading) {
    return (
      <div className="bg-gray-900 px-4 sm:px-6 lg:px-20 min-h-screen flex items-center justify-center">
        <p className="text-white">Loading...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="bg-gray-900 px-4 sm:px-6 lg:px-20 min-h-screen flex items-center justify-center">
        <p className="text-white">Error: {error}</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-900">
      <Navbar />
      <div className="pt-16 px-4 sm:px-6 lg:px-16 h-[calc(100vh-4rem)]">
        <div className="container mx-auto">
          <h2 className="text-white text-lg sm:text-xl font-bold mb-3 sm:mb-6 pt-3 sm:pt-4">Game Shows</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4 lg:gap-6">
            {gameShows.map((show) => (
              <div 
                key={show.gameShowId} 
                onClick={() => navigate(`/gameshow/${show.gameShowId}`)}
                className="cursor-pointer transform transition-transform duration-200 hover:scale-105"
              >
                <div className="bg-gray-800 rounded-lg overflow-hidden shadow-lg h-full">
                  <div className="aspect-w-16 aspect-h-12">
                    <img
                      src={show.profileImage}
                      alt={show.name}
                      className="w-full h-40 object-cover"
                    />
                  </div>
                  <div className="p-3 sm:p-4">
                    <h3 className="text-white text-base sm:text-lg font-bold mb-1">{show.name}</h3>
                    <p className="text-gray-400 mb-2 text-xs sm:text-sm">{show.description}</p>
                    <div className="text-gray-300 text-xs">
                      <p className="mb-0.5">
                        <span className="font-semibold">Date:</span>{' '}
                        {new Date(show.date).toLocaleDateString()}
                      </p>
                      <p>
                        <span className="font-semibold">Time:</span>{' '}
                        {show.startTime}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default GameShowsPage;
